export default {
  "content": "<style/><path d=\"M256 56c110.5 0 200 89.5 200 200s-89.5 200-200 200S56 366.5 56 256 145.5 56 256 56zm0-48C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z\"/><path d=\"M376 232h-96v-96c0-4.4-3.6-8-8-8h-32c-4.4 0-8 3.6-8 8v96h-96c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h96v96c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8v-96h96c4.4 0 8-3.6 8-8v-32c0-4.4-3.6-8-8-8z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 512 512"
  }
};